
import MobileNavigation from './MobileNavigation'
import LocaleChanger from './LocaleChanger'

export default {
  name: 'AppHeader',
  components: { LocaleChanger, MobileNavigation },
  computed: {
    showLanguageMenu () {
      return this.$store.state.showLanguageMenu
    }
  },
  watch: {
    '$i18n.locale' () {
      this.commitLanguage()
    }
  },
  mounted () {
    this.commitLanguage()
  },
  methods: {
    commitLanguage () {
      this.$store.commit('SET_LANGUAGE_MENU', this.$i18n.getBrowserLocale() !== this.$i18n.locale)
    }
  }
}
